import React from 'react';

import { IRegionProps } from '@source/interface';
import Layout from '@source/components/Layout';
import CCPOInspectionPointList from '@source/pages/CarroCertified/components/CCPOInspectionPointList';
import HeadMeta from '@source/pages/Home/components/HeadMeta';

const CCPOInspectionPointListContainer = ({ region }: IRegionProps) => (
  <Layout hideBanner>
    <HeadMeta metaKey="ccpoIndex" region={region} />
    <CCPOInspectionPointList />
  </Layout>
);

export default CCPOInspectionPointListContainer;
